import {
  GOOGLE_LOGIN_START,
  GOOGLE_LOGIN_ERROR,
  GOOGLE_LOGIN_SUCCESS
} from './actions'

const initialState = window.__STATE__.googleAuth || {}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GOOGLE_LOGIN_START:
      return {
        ...state,
        isProcessing: true,
      }
    case GOOGLE_LOGIN_SUCCESS:
    case GOOGLE_LOGIN_ERROR:
      return {
        ...state,
        isProcessing: false,
        response: action.response,
        error: action.error,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/Modules/AuthGoogle/reducer.js